import { Component, inject, input } from "@angular/core";
import { OverlayModule } from "@angular/cdk/overlay";
import { AsyncPipe } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
import { SearchBarComponent } from "@shared/components/molecules/search-bar/search-bar.component";
import { ProductCategoryMenuComponent } from "@shared/components/organisms/product-category-menu/product-category-menu.component";
import { CategoryService } from "@shared/services/category.service";

@Component({
  selector: "app-navigation-bar",
  imports: [OverlayModule, SearchBarComponent, ProductCategoryMenuComponent, AsyncPipe, TranslatePipe],
  templateUrl: "./navigation-bar.component.html",
  styleUrl: "./navigation-bar.component.scss",
})
export class NavigationBarComponent {
  isShowCategoryButton = input<boolean>(true);

  private readonly categoryService = inject(CategoryService);

  readonly navigationCategories$ = this.categoryService.getAllNavigationCategories();
}
